import { DataObject } from '../../models/report.model';
import { groupCompaniesContacts } from './group-company-contacts';

export function extractCompanies(companyContactEntries): Array<DataObject> {
  return groupCompaniesContacts(companyContactEntries || []);
}

export interface PreprocessorCompanyContacts {
  processCompanyContacts(record: DataObject): DataObject;
}
